import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appSetReadOnly]',
})
export class ReadonlyObserverDirective {
  private observer: MutationObserver;
  @Input() set appSetReadOnly(value: boolean) {
    this.updateReadonlyAttribute(value);
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {
    // Initialize the observer
    this.observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'readonly'
        ) {
          // If the readonly attribute is removed, set it again
          if (!this.el.nativeElement.hasAttribute('readonly')) {
            this.renderer.setAttribute(
              this.el.nativeElement,
              'readonly',
              'true'
            );
          }
        }
      });
    });

    // Observe changes to the element's attributes
    this.observer.observe(this.el.nativeElement, { attributes: true });
  }

  private updateReadonlyAttribute(isReadonly: boolean = false) {
    const inputElement = this.el.nativeElement;
    if (isReadonly) {
      inputElement.setAttribute('readonly', 'true');
    } else {
      inputElement.removeAttribute('readonly');
    }
  }

  ngOnDestroy() {
    // Disconnect the observer when the directive is destroyed
    this.observer.disconnect();
  }
}
